import React, { useState } from 'react';
import { getAvailablePlayers, sortPlayers } from '../../utils/playerHelpers';
import './Position.css';

const Position = ({
  position,
  onClose,
  onSelect,
  availablePlayers,
  selectedPlayers,
  draftedPlayers,
  config
}) => {
  const [sorting, setSorting] = useState({ field: 'projected', direction: 'desc' });
  const [searchText, setSearchText] = useState('');

  const handleSort = (field) => {
    setSorting(prev => ({
      field,
      direction: prev.field === field && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const sortArrow = (field) =>
    sorting.field === field ? (sorting.direction === 'asc' ? ' ↑' : ' ↓') : '';

  const getAvailablePlayersForPosition = () => {
    const players = getAvailablePlayers(position, availablePlayers);
    return players.filter(player => !selectedPlayers.has(player.name));
  };

  const getPositionSlots = () => {
    let slots = [];
    Object.entries(draftedPlayers).forEach(([teamIndex, players]) => {
      Object.entries(players).forEach(([slot, player]) => {
        if (player && player.position === position) {
          slots.push({
            team: parseInt(teamIndex) + 1,
            player: player.name,
            projected: player.projected
          });
        }
      });
    });
    return slots;
  };

  const availableForPosition = getAvailablePlayersForPosition();
  const positionPlayers = sortPlayers(
    availableForPosition.filter(player =>
      player.name.toLowerCase().includes(searchText.toLowerCase())
    ),
    sorting
  );
  const draftedPositionSlots = getPositionSlots();
  const positionLimit = config.positions[position] || 0;
  const remainingSlots = positionLimit - draftedPositionSlots.length;

  return (
    <div className="position-dialog">
      <div className="position-header">
        <h2>{position} Players</h2>
        <button className="close-button" onClick={onClose}>Close</button>
      </div>

      <div className="position-content">
        <div className="position-stats">
          <div className="stat-item">
            <span className="stat-label">Position Limit:</span>
            <span className="stat-value">{positionLimit}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Remaining Slots:</span>
            <span className="stat-value">{remainingSlots}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Available Players:</span>
            <span className="stat-value">{availableForPosition.length}</span>
          </div>
        </div>

        <div className="players-section">
          <h3>Available Players</h3>
          <input
            type="text"
            className="players-search"
            placeholder="Search players..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <div className="players-list-header">
            <span className="player-team" onClick={() => handleSort('team')}>
              Team{sortArrow('team')}
            </span>
            <span className="player-name" onClick={() => handleSort('name')}>
              Name{sortArrow('name')}
            </span>
            <span className="player-projected" onClick={() => handleSort('projected')}>
              Projected{sortArrow('projected')}
            </span>
          </div>
          <div className="players-list">
            {positionPlayers.map((player, index) => (
              <div
                key={index}
                className="player-item"
                onClick={() => onSelect(player)}
              >
                <span className="player-team">{player.team}</span>
                <span className="player-name">{player.name}</span>
                <span className="player-projected">{player.projected.toFixed(1)}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="drafted-section">
          <h3>Drafted Players</h3>
          <div className="drafted-list">
            {draftedPositionSlots.map((slot, index) => (
              <div key={index} className="drafted-item">
                <span className="team-number">Team {slot.team}</span>
                <span className="player-name">{slot.player}</span>
                <span className="player-projected">{slot.projected.toFixed(1)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Position;